import React from 'react';
import { Copy } from '@grubhubprod/gh-cookbook-react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { CookbookCheckboxWrapper } from 'src/components/CookbookCheckboxWrapper/CookbookCheckboxWrapper';
import { CustomLabelWithTooltip } from 'src/components/common/CustomLabelWithTooltip/CustomLabelWithTooltip';

export interface SSORedirectControlProps {
  name: string;
  id: string;
}

export function SSORedirectControl({
  name,
  id,
}: SSORedirectControlProps): JSX.Element {
  const { control } = useFormContext();

  return (
    <CookbookCheckboxWrapper
      control={control}
      id={id}
      name={name}
      label={
        <CustomLabelWithTooltip
          color="primaryText"
          labelText="Allow SSO on native app"
          tooltipInfo={
            <Copy variant="body" color="invertedPrimaryText">
              This would allow SSO for customers logging in on our native app
              (iOS and Android).
            </Copy>
          }
        />
      }
    />
  );
}
